import React from 'react';
import { View, Text, TextInput, StyleSheet } from 'react-native';
import { RESIDENTS_DESKTOP_COLORS } from '@/constants/residents/desktop/color';

interface PaymentAmountInputProps {
  value: string;
  onChangeText: (text: string) => void;
  placeholder?: string;
  editable?: boolean;
  disabled?: boolean;
  style?: any;
  inputStyle?: any;
}

export const PaymentAmountInput: React.FC<PaymentAmountInputProps> = ({
  value,
  onChangeText,
  placeholder = '0.00',
  editable = true,
  disabled = false,
  style,
  inputStyle,
}) => {
  return (
    <View style={[styles.amountInputWrap, style]}>
      <Text style={[styles.currencyPrefix, disabled && styles.disabledText]}>$</Text>
      <TextInput
        style={[
          styles.amountInput,
          disabled && styles.amountInputDisabled,
          inputStyle,
        ]}
        editable={editable && !disabled}
        keyboardType="decimal-pad"
        value={value}
        onChangeText={onChangeText}
        placeholder={placeholder}
        placeholderTextColor={RESIDENTS_DESKTOP_COLORS.TEXT_TERTIARY}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  amountInputWrap: {
    flexDirection: 'row',
    alignItems: 'center',
    minWidth: 180,
    justifyContent: 'flex-end',
  },
  currencyPrefix: {
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
    marginRight: 6,
  },
  amountInput: {
    width: 160,
    height: 44,
    borderRadius: 10,
    borderWidth: 1,
    // borderColor: 'rgba(255,255,255,0.12)',
    borderColor: RESIDENTS_DESKTOP_COLORS.SECONDARY_BACKGROUND,
    backgroundColor: 'transparent',
    paddingHorizontal: 12,
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
  },
  amountInputDisabled: {
    opacity: 0.4,
  },
  disabledText: {
    opacity: 0.4,
  },
});
